import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

export type WorkflowStepId =
  | 'discovery'
  | 'design'
  | 'multiagent'
  | 'technical'
  | 'codegen'
  | 'operations';

interface HelpLinkProps {
  step: WorkflowStepId;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const stepLabels: Record<WorkflowStepId, string> = {
  discovery: 'Discovery',
  design: 'Design',
  multiagent: 'Multi-Agent Architecture',
  technical: 'Technical Architecture',
  codegen: 'Code Generation',
  operations: 'Operations Planning',
};

/**
 * HelpLink component provides contextual help links to the User Guide.
 * Each workflow step can use this component to link to its relevant
 * section in the guide.
 */
export const HelpLink: React.FC<HelpLinkProps> = ({
  step,
  size = 'small',
  className,
}) => {
  const label = stepLabels[step];

  return (
    <Tooltip title={`Learn more about ${label}`} arrow>
      <IconButton
        component={RouterLink}
        to={`/guide#step-${step}`}
        size={size}
        aria-label={`Help for ${label} step`}
        className={className}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
            bgcolor: 'primary.50',
          },
        }}
      >
        <HelpOutlineIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default HelpLink;
